import CIMSCollapse from 'components/CIMSCollapse'
import { useCASRoutingGroupsPanel } from './hooks/useCASRoutingGroupsPanel'
import { useDSDisciplinesPanel } from './hooks/useDSDisciplinesPanel'
import { useFDCGroupsPanel } from './hooks/useFDCGroupsPanel'
import { useRFIResponseDisciplinesPanel } from './hooks/useRFIResponseDisciplinesPanel'
import { useCustomFieldsPanel } from './hooks/useCustomFieldsPanel'
import { useImplicitPermissions } from './hooks/useImplicitPermissions'
import { ImplicitPermissionsProps } from './hooks/useImplicitPermissions/types'
import { useEJTypesPanel } from './hooks/useEJTypesPanel'

const ImplicitPermissionViewer: React.VFC<ImplicitPermissionsProps> = (
  props
) => {
  const {
    casRoutingGroups,
    dsDisciplines,
    fdcApprovalGroups,
    fdcConcurrenceGroups,
    rfiResponseDisciplines,
    ejTypes,
    customFields,
  } = useImplicitPermissions(props)
  return (
    <CIMSCollapse
      panels={[
        ...useCASRoutingGroupsPanel(casRoutingGroups),
        ...useDSDisciplinesPanel(dsDisciplines),
        ...useFDCGroupsPanel({
          fdcApprovalGroups,
          fdcConcurrenceGroups,
        }),
        ...useRFIResponseDisciplinesPanel(rfiResponseDisciplines),
        ...useEJTypesPanel(ejTypes),
        ...useCustomFieldsPanel(customFields),
      ]}
    />
  )
}

export default ImplicitPermissionViewer
